/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Rooms_AddInputs */



/**
* | output |
* | --- |
* | "Add Room" |
*
* @param {Rooms_AddInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const rooms_add = /** @type {((inputs?: Rooms_AddInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Rooms_AddInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Ajouter une salle")
	if (locale === "es") return /** @type {LocalizedString} */ ("Añadir sala")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Adicionar sala")
	if (locale === "it") return /** @type {LocalizedString} */ ("Aggiungi sala")
	return /** @type {LocalizedString} */ ("Add Room")
});